<template>
  <div id="Partner">
  	<ul class="list">
  		<div class="title">合作银行</div>
  		<li v-for="bank of partner.banks">
				<a href="">
  				<!-- <span><img :src="bank.content"/></span> -->
					<span><img src="http://www.92qb.cn/uploads/ueditor/image/20171110/1510280123268830.jpeg"/></span>
					<h3 class="name" v-text="bank.title"></h3>
					<div class="desc">办卡送某某东西</div>
					<div class="now">立即办理</div>
				</a>
  		</li>
  		<div class="title">合作机构</div>
  		<li v-for="loan of partner.loans">
  			<span><img :src="loan.content"/></span>
        <div class="name" v-text="loan.title"></div>
				<div class="desc">办卡送某某东西</div>
				<div class="now">立即办理</div>
  		</li>
  	</ul>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Partner',
  data () {
    return {
		partner: {},
    }
  },
  created() {
  	this.getPartner();
  },
  methods: {
  	getPartner() {
  		let params = new URLSearchParams();
  		var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/wx/partner/list',
  		}).then(function(res){
  			_this.partner = res.data.data;
  		})
  	}
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">	
	#Partner
		.list
			font-size: 0
			.title
				width: 100%
				height: 40px
				line-height: 50px
				padding-left: 15px
				font-size: 14px
			li
				display: inline-block
				width: 234px
				height: 165px
				margin: 1.66%
				padding: 10px 0
				background: #fff
				text-align: center
				font-size: 12px
				transition: all .2s linear 
				&:hover
					z-index: 2
					box-shadow: 0 15px 30px rgba(0,0,0,0.1)
					transform: translate3d(0,-2px,0)
				span
					display: block
					padding: 5px 0
					img 
						width: 50%
				.name
					color: #000
					font-size: 14px
					font-weight: 400
					margin: 0 10px 7px
				.desc
					margin: 0 10px 10px
					height: 18px
					font-size: 12px
					text-align: center 
					text-overflow: ellipsis
					white-space: nowrap
					overflow: hidden
					color: #b0b0b0
				.now
					margin: 0 10px 14px
					color: #ff6700
</style>


// WEBPACK FOOTER //
// src/components/partner/partner.vue